'use strict';

wo$(function () {
    var defaultCriteria = {
        tabletSizeSmall: true,
        tabletSizeMedium: true,
        tabletSizeLarge: true,

        paymentTypeUpfront: true,
        paymentTypePlan: true,

        brands: [],

        filter: '',

        showEditorsPickOnly: false,

        sortBy: 'popular'
    };

    var controller = {
        show: function (wizardMode, selectedHandler) {
            controller.init(wizardMode, selectedHandler);

            controller.tabletModal.modal('show');
        },

        initModel: function () {
            controller.wizardMode = false;
            controller.tabletSelectedHandler = null;
            controller.pageHeight = null;
            controller.currentStep = null;
            controller.tablets = [];
            controller.maxTablets = 16;
            controller.filteredTablets = [];
            controller.filteredTabletsAllBrands = [];
            controller.criteria = wo$.extend(true, {}, defaultCriteria);
            controller.criteria.maxUpfront = controller.modalData.defaultMaxUpfront;
            controller.hasValidationErrors = false;
            controller.applicablePaymentTypes = [];
            controller.stepsConfig = [];
            controller.normalSteps = [0];
            controller.embeddedModeSteps = [0];
            controller.steps = null;
            controller.currentStepIndex = null;
        },

        init: function (wizardMode, selectedHandler, parentElement) {
            if (parentElement) {
                controller.tabletModal = parentElement;
                controller.isEmbedded = true;
            } else {
                controller.tabletModal = wo$('#modal-tablet-picker');
                controller.isEmbedded = false;
            }

            if (!controller.tabletModal.length) return;

            controller.modalData = WhistleOut.readLookupData(controller.tabletModal, true);
            var showBrandStep = controller.modalData.brands.length > 1;
            controller.initModel(showBrandStep, controller.modalData.showPaymentOptions);

            WhistleOut.applySelectPicker(controller.tabletModal.find('.selectpicker'), {
                countSelectedText: controller.dropdownDisplay
            });
            WhistleOut.applySelectPickersStyle(controller.tabletModal);

            if (controller.isEmbedded) {
                controller.tabletModal.find('div.bootstrap-select button').addClass('btn-sm');
            }

            controller.stepsConfig = controller.modalData.stepsConfig;
            controller.applicablePaymentTypes = controller.modalData.applicablePaymentTypes;
            controller.criteria.brands = controller.modalData.brands;
            controller.tablets = controller.modalData.tablets;
            controller.filteredTablets = controller.tablets.slice().sort(function (a, b) {
                if (a.id === -1) return -1;
                if (a.rank < b.rank) return -1;
                if (a.rank > b.rank) return 1;
                return 0;
            });

            controller.wizardMode = wizardMode;
            controller.tabletSelectedHandler = selectedHandler;

            if (parentElement) {
                controller.steps = controller.embeddedModeSteps;
            } else {
                controller.steps = controller.wizardMode ? controller.wizardSteps : controller.normalSteps;
            }

            controller.tabletModal
                .find('[data-continue-button]')
                .off()
                .click(function () {
                    controller.setCurrentStep(controller.currentStepIndex + 1);
                });

            controller.tabletModal
                .find('[data-back-button]')
                .off()
                .click(function () {
                    controller.setCurrentStep(controller.currentStepIndex - 1);
                });

            controller.tabletModal.on('hidden.bs.modal', function () {
                controller.cleanup();
            });

            controller.tabletModal.on('shown.bs.modal', function () {
                controller.pageHeight = wo$(window).height();
            });

            controller.setCurrentStep(0);
            controller.filterTablets();
        },

        cleanup: function () {
            controller.maxTablets = 4;
            controller.maxTabletsAdvanced = 16;
            controller.currentStepIndex = null;
            controller.criteria = wo$.extend(true, {}, defaultCriteria);
            controller.tabletModal.find('input[type="checkbox"]').prop('checked', true);
            controller.tabletModal.off();
        },

        dropdownDisplay: function (selectedCount, totalCount) {
            if (selectedCount === totalCount) {
                return controller.modalData.allText;
            }
            return controller.modalData.selectedText.replace('{0}', selectedCount);
        },

        setCurrentStep: function (stepIndex) {
            if (stepIndex >= controller.steps.length) {
                controller.tabletSelectedHandler(controller.selectedTablet);
                return;
            }

            controller.maxTablets = 4;
            controller.maxTabletsAdvanced = controller.isEmbedded ? 14 : 16;
            controller.criteria.showEditorsPickOnly = false;
            controller.tabletModal.find('#tablet-include-dropdown').selectpicker('val', 'all');

            if (controller.currentStepIndex != null) {
                // If not initial load

                if (controller.hasValidationErrors && stepIndex > controller.currentStepIndex) {
                    return;
                }

                controller.saveToCriteria();
            }

            controller.currentStepIndex = stepIndex;
            controller.currentStep = controller.stepsConfig[controller.steps[stepIndex]];
            controller.tabletModal.find('[data-step]').hide();
            controller.tabletModal.find('[data-step-number]').text(stepIndex + 1);
            controller.tabletModal.find('[data-step-title]').text(controller.currentStep.title);

            if (
                controller.currentStep.name === 'filter-options' ||
                controller.currentStep.name === 'filter-options-advanced' ||
                controller.currentStep.name === 'tablet-closest-matches'
            ) {
                controller.tabletModal.find('[data-continue-button]').addClass('invisible');
            } else {
                controller.tabletModal.find('[data-continue-button]').removeClass('invisible');
            }

            if (stepIndex === 0) {
                controller.tabletModal.find('[data-back-button]').hide();
            } else {
                controller.tabletModal.find('[data-back-button]').show();
            }

            controller.loadFromCriteria();

            controller.tabletModal.find('[data-step="' + controller.currentStep.name + '"]').show();
        },

        loadFromCriteria: function () {
            if (controller.currentStep.name === 'tablet-size') {
                controller.tabletModal.find('input[id^=tablet-size-]').prop('checked', true);
                if (controller.criteria.tabletSizeSmall === false) {
                    controller.tabletModal.find('#tablet-size-small').prop('checked', false);
                }
                if (controller.criteria.tabletSizeMedium === false) {
                    controller.tabletModal.find('#tablet-size-medium').prop('checked', false);
                }
                if (controller.criteria.tabletSizeLarge === false) {
                    controller.tabletModal.find('#tablet-size-large').prop('checked', false);
                }
                controller.tabletModal
                    .find('input[id^=tablet-size-]')
                    .off()
                    .change(function () {
                        controller.saveToCriteria();
                    });
            } else if (controller.currentStep.name === 'payment-type') {
                controller.tabletModal.find('input[id^=price-type-]').prop('checked', true);
                if (controller.criteria.paymentTypeUpfront === false) {
                    controller.tabletModal.find('#price-type-upfront').prop('checked', false);
                }
                if (controller.criteria.paymentTypePlan === false) {
                    controller.tabletModal.find('#price-type-plan').prop('checked', false);
                }
                controller.tabletModal
                    .find('input[id^=price-type-]')
                    .off()
                    .change(function () {
                        controller.saveToCriteria();
                    });
            } else if (controller.currentStep.name === 'tablet-brand') {
                controller.tabletModal
                    .find('#select-all-brands')
                    .off()
                    .click(function () {
                        controller.tabletModal.find('[data-brand]').prop('checked', true);
                        controller.saveToCriteria();
                    });

                controller.tabletModal
                    .find('#unselect-all-brands')
                    .off()
                    .click(function () {
                        controller.tabletModal.find('[data-brand]').prop('checked', false);
                        controller.saveToCriteria();
                    });

                controller.tabletModal.find('[data-brand]').prop('checked', false);
                controller.criteria.brands.filter(function (brand) {
                    controller.tabletModal.find('input[id="tablet-brand-' + brand + '"]').prop('checked', true);
                });
                controller.tabletModal
                    .find('input[id^=tablet-brand-]')
                    .off()
                    .change(function () {
                        controller.saveToCriteria();
                    });
            } else if (
                controller.currentStep.name === 'filter-options' ||
                controller.currentStep.name === 'filter-options-advanced'
            ) {
                controller.showTablets();

                controller.tabletModal.find('[data-continue-button]').addClass('invisible');

                var popoverButton = controller.tabletModal.find('[data-tablets-panel] [data-editors-pick-button]');
                popoverButton.popover();

                controller.tabletModal
                    .find('[data-step="' + controller.currentStep.name + '"] #load-more-tablets')
                    .off()
                    .click(function () {
                        if (controller.currentStep.name === 'filter-options') {
                            controller.maxTablets += 4;
                        } else {
                            controller.maxTabletsAdvanced += controller.isEmbedded ? 14 : 16;
                        }
                        controller.showTablets(true);

                        var maxItems =
                            controller.currentStep.name === 'filter-options'
                                ? controller.maxTablets
                                : controller.maxTabletsAdvanced;
                        if (controller.filteredTablets.length <= maxItems) {
                            controller.tabletModal
                                .find('[data-step="' + controller.currentStep.name + '"] #load-more-tablets')
                                .hide();
                        } else {
                            controller.tabletModal
                                .find('[data-step="' + controller.currentStep.name + '"] #load-more-tablets')
                                .show();
                        }
                    });
                var maxItems =
                    controller.currentStep.name === 'filter-options'
                        ? controller.maxTablets
                        : controller.maxTabletsAdvanced;
                if (controller.filteredTablets.length <= maxItems) {
                    controller.tabletModal
                        .find('[data-step="' + controller.currentStep.name + '"] #load-more-tablets')
                        .hide();
                } else {
                    controller.tabletModal
                        .find('[data-step="' + controller.currentStep.name + '"] #load-more-tablets')
                        .show();
                }

                var tabletSizes = [];
                if (controller.criteria.tabletSizeSmall === true) {
                    tabletSizes.push('small');
                }
                if (controller.criteria.tabletSizeMedium === true) {
                    tabletSizes.push('medium');
                }
                if (controller.criteria.tabletSizeLarge === true) {
                    tabletSizes.push('large');
                }
                controller.tabletModal
                    .find('[data-step="' + controller.currentStep.name + '"] #tablet-size-dropdown')
                    .selectpicker('val', tabletSizes);
                controller.tabletModal
                    .find('[data-step="' + controller.currentStep.name + '"] #tablet-size-dropdown')
                    .off('change', controller.updateTabletsFilters)
                    .on('change', controller.updateTabletsFilters);

                if (controller.modalData.showMaxUpfront) {
                    var maxUpfrontDropdown = controller.tabletModal.find(
                        '[data-step="' + controller.currentStep.name + '"] #tablet-max-upfront-dropdown'
                    );
                    maxUpfrontDropdown.selectpicker('val', controller.criteria.maxUpfront);
                    maxUpfrontDropdown
                        .off('change', controller.updateTabletsFilters)
                        .on('change', controller.updateTabletsFilters);
                } else {
                    var paymentTypes = [];
                    if (controller.criteria.paymentTypeUpfront === true) {
                        paymentTypes.push('upfront');
                    }
                    if (controller.criteria.paymentTypePlan === true) {
                        paymentTypes.push('plan');
                    }
                    controller.tabletModal
                        .find('[data-step="' + controller.currentStep.name + '"] #tablet-payment-type-dropdown')
                        .selectpicker('val', paymentTypes);
                    controller.tabletModal
                        .find('[data-step="' + controller.currentStep.name + '"] #tablet-payment-type-dropdown')
                        .off('change', controller.updateTabletsFilters)
                        .on('change', controller.updateTabletsFilters);
                }

                controller.tabletModal
                    .find('[data-step="' + controller.currentStep.name + '"] #tablet-brand-dropdown')
                    .selectpicker('val', controller.criteria.brands);
                controller.tabletModal
                    .find('[data-step="' + controller.currentStep.name + '"] #tablet-brand-dropdown')
                    .off('change', controller.updateTabletsFilters)
                    .on('change', controller.updateTabletsFilters);

                controller.tabletModal
                    .find('[data-step="' + controller.currentStep.name + '"] #tablet-include-dropdown')
                    .off('change', controller.updateTabletsFilters)
                    .on('change', controller.updateTabletsFilters);

                controller.tabletModal
                    .find('[data-step="' + controller.currentStep.name + '"] #sort-dropdown')
                    .off('change', controller.updateTabletsFilters)
                    .on('change', controller.updateTabletsFilters);

                controller.tabletModal
                    .find('[data-step="' + controller.currentStep.name + '"] #tablet-search')
                    .val(controller.criteria.filter);
                controller.tabletModal
                    .find('[data-step="' + controller.currentStep.name + '"] #tablet-search')
                    .off()
                    .keyup(function () {
                        controller.updateTabletsFilters(true);
                    });

                controller.bindChooseButtons();
            } else if (controller.currentStep.name === 'tablet-closest-matches') {
                var noteSpan = controller.tabletModal.find('[data-closest-match-note]');
                noteSpan.html(
                    noteSpan.text().replace('{0}', '<strong>' + controller.selectedTablet.name + '</strong>')
                );

                var image = controller.tabletModal.find('[data-closest-match-image]');
                image.attr('alt', controller.selectedTablet.singleSupplierName);
                image.attr('src', controller.selectedTablet.singleSupplierImageUrl);

                controller.tabletModal
                    .find('[data-yes-button]')
                    .off()
                    .click(function () {
                        controller.selectedTablet.similarTablets = true;
                        controller.tabletModal.modal('hide');
                        controller.tabletSelectedHandler(controller.selectedTablet);
                    });
                controller.tabletModal
                    .find('[data-no-button]')
                    .off()
                    .click(function () {
                        controller.selectedTablet.similarTablets = false;
                        controller.tabletModal.modal('hide');
                        controller.tabletSelectedHandler(controller.selectedTablet);
                    });
            }
        },

        getPaymentTypes: function () {
            var types = [];
            if (controller.criteria.paymentTypeUpfront) {
                types.push('Outright');
            }
            if (controller.criteria.paymentTypePlan) {
                wo$.merge(
                    types,
                    controller.applicablePaymentTypes.filter(function (pt) {
                        return pt !== 'Outright';
                    })
                );
            }
            return types;
        },

        bindChooseButtons: function () {
            controller.tabletModal
                .find('[data-step="' + controller.currentStep.name + '"] [data-choose-button]')
                .off()
                .click(function () {
                    var shortUrl = wo$(this).data('choose-button');
                    controller.selectedTablet = controller.tablets.filter(function (p) {
                        return p.shortUrl === shortUrl;
                    })[0];
                    controller.selectedTablet.priceTypes = controller.getPaymentTypes();

                    if (controller.selectedTablet.showSimilarTabletsStep === true) {
                        controller.setCurrentStep(controller.currentStepIndex + 1);
                    } else {
                        controller.tabletModal.modal('hide');
                        controller.tabletSelectedHandler(controller.selectedTablet);
                    }
                });

            controller.tabletModal
                .find('[data-step="' + controller.currentStep.name + '"] [data-show-byo-button]')
                .off();
            WhistleOut.Tablets.bindByoPopover(
                controller.tabletModal.find('[data-step="' + controller.currentStep.name + '"] [data-show-byo-button]'),
                controller.modalData.byoPopoverTitle,
                controller.modalData.byoPopoverContent,
                function (simType, simTypeName) {
                    controller.selectedTablet = controller.tablets.filter(function (p) {
                        return p.shortUrl === null;
                    })[0];
                    controller.selectedTablet.priceTypes = [];
                    controller.selectedTablet.simType = simType;
                    controller.selectedTablet.simTypeName = simTypeName;
                    controller.tabletModal.modal('hide');
                    controller.tabletSelectedHandler(controller.selectedTablet);
                },
                'right'
            );
        },

        updateTabletsFilters: function (noAnimation) {
            if (noAnimation !== true) {
                noAnimation = false;
            }
            controller.maxTablets = 4;
            controller.maxTabletsAdvanced = controller.isEmbedded ? 14 : 16;
            controller.saveToCriteria();
            controller.showTablets(null, noAnimation);
            var maxItems =
                controller.currentStep.name === 'filter-options'
                    ? controller.maxTablets
                    : controller.maxTabletsAdvanced;
            if (controller.filteredTablets.length <= maxItems) {
                controller.tabletModal
                    .find('[data-step="' + controller.currentStep.name + '"] #load-more-tablets')
                    .hide();
            } else {
                controller.tabletModal
                    .find('[data-step="' + controller.currentStep.name + '"] #load-more-tablets')
                    .show();
            }
        },

        showTablets: function (append, noAnimation) {
            var panel = controller.tabletModal.find(
                '[data-step="' + controller.currentStep.name + '"] [data-tablets-panel]'
            );
            var startFrom = 0;

            if (append) {
                var currentlyShowing = controller.tabletModal.find(
                    '[data-step="' + controller.currentStep.name + '"] [data-tablets-panel] [data-tablet-short-url]'
                ).length;
                startFrom = currentlyShowing;
            } else {
                panel.html('');
            }

            var maxItems =
                controller.currentStep.name === 'filter-options'
                    ? controller.maxTablets
                    : controller.maxTabletsAdvanced;
            wo$.each(controller.filteredTablets, function (index, tablet) {
                if (index >= maxItems) return;

                if (index >= startFrom) {
                    controller.insertTabletItem(tablet, panel, noAnimation);
                }
            });

            var popoverButton = controller.tabletModal.find('[data-tablets-panel] [data-editors-pick-button]');
            popoverButton.popover();

            controller.bindChooseButtons();
        },

        insertTabletItem: function (tablet, panel, noAnimation) {
            var tabletTemplateHtml = controller.tabletModal
                .find('[data-step="' + controller.currentStep.name + '"] div#tablet-item-template')
                .html();

            if (tablet.id === -1) {
                tabletTemplateHtml = tabletTemplateHtml.replace('{{button-data}}', 'data-show-byo-button');
            } else {
                tabletTemplateHtml = tabletTemplateHtml.replace('{{button-data}}', 'data-choose-button');
            }

            tabletTemplateHtml = tabletTemplateHtml.replace(/{{SHORT-URL}}/g, tablet.shortUrl);
            tabletTemplateHtml = tabletTemplateHtml.replace(
                /data-image-url="{{IMAGE-URL}}"/g,
                'src="' + tablet.imageUrl.medium + '"'
            );
            tabletTemplateHtml = tabletTemplateHtml.replace(/{{NAME}}/g, tablet.name);
            tabletTemplateHtml = tabletTemplateHtml.replace(/{{BRAND-NAME}}/g, tablet.manufacturerName);
            tabletTemplateHtml = tabletTemplateHtml.replace(
                /{{EDITORS-PICK-STYLE}}/g,
                tablet.isEditorsPick ? '' : 'display:none;'
            );
            tabletTemplateHtml = tabletTemplateHtml.replace(/{{EDITORS-PICK-TEXT}}/g, tablet.editorsPickText);
            if (tablet.features && tablet.features.length >= 4) {
                tabletTemplateHtml = tabletTemplateHtml.replace(/{{FEATURE-1}}/g, tablet.features[0]);
                tabletTemplateHtml = tabletTemplateHtml.replace(/{{FEATURE-2}}/g, tablet.features[1]);
                tabletTemplateHtml = tabletTemplateHtml.replace(/{{FEATURE-3}}/g, tablet.features[2]);
                tabletTemplateHtml = tabletTemplateHtml.replace(/{{FEATURE-4}}/g, tablet.features[3]);
            }

            var availableFrom =
                tablet.supplierCount === 1
                    ? controller.modalData.carrier1
                    : controller.modalData.carrierX.replace('{0}', tablet.supplierCount);
            tabletTemplateHtml = tabletTemplateHtml.replace(/{{AVAILABLE-FROM}}/g, availableFrom);

            var li = wo$(tabletTemplateHtml);

            if (noAnimation) {
                panel.append('\n\t');
                li.appendTo(panel).show();
            } else {
                panel.append('\n\t');
                li.appendTo(panel).fadeIn('medium');
            }
        },

        saveToCriteria: function () {
            if (controller.currentStep.name === 'tablet-size') {
                controller.criteria.tabletSizeSmall = controller.tabletModal.find('#tablet-size-small').prop('checked');
                controller.criteria.tabletSizeMedium = controller.tabletModal
                    .find('#tablet-size-medium')
                    .prop('checked');
                controller.criteria.tabletSizeLarge = controller.tabletModal.find('#tablet-size-large').prop('checked');
            } else if (controller.currentStep.name === 'payment-type') {
                controller.criteria.paymentTypeUpfront = controller.tabletModal
                    .find('#price-type-upfront')
                    .prop('checked');
                controller.criteria.paymentTypePlan = controller.tabletModal.find('#price-type-plan').prop('checked');
            } else if (controller.currentStep.name === 'tablet-brand') {
                controller.criteria.brands = [];
                controller.tabletModal.find('input[id^=tablet-brand-]:checked').each(function () {
                    controller.criteria.brands.push(wo$(this).attr('data-brand'));
                });
            } else if (
                controller.currentStep.name === 'filter-options' ||
                controller.currentStep.name === 'filter-options-advanced'
            ) {
                controller.criteria.tabletSizeSmall = false;
                controller.criteria.tabletSizeMedium = false;
                controller.criteria.tabletSizeLarge = false;
                var sizes = controller.tabletModal
                    .find('[data-step="' + controller.currentStep.name + '"] #tablet-size-dropdown')
                    .selectpicker('val');
                if (sizes && sizes.length > 0) {
                    wo$.each(sizes, function (index, size) {
                        if (size === 'small') {
                            controller.criteria.tabletSizeSmall = true;
                        } else if (size === 'medium') {
                            controller.criteria.tabletSizeMedium = true;
                        } else if (size === 'large') {
                            controller.criteria.tabletSizeLarge = true;
                        }
                    });
                }

                if (controller.modalData.showMaxUpfront) {
                    controller.criteria.maxUpfront = parseInt(
                        controller.tabletModal
                            .find('[data-step="' + controller.currentStep.name + '"] #tablet-max-upfront-dropdown')
                            .selectpicker('val')
                    );
                } else {
                    controller.criteria.paymentTypeUpfront = false;
                    controller.criteria.paymentTypePlan = false;
                    var types = controller.tabletModal
                        .find('[data-step="' + controller.currentStep.name + '"] #tablet-payment-type-dropdown')
                        .selectpicker('val');
                    if (types && types.length > 0) {
                        wo$.each(types, function (index, type) {
                            if (type === 'upfront') {
                                controller.criteria.paymentTypeUpfront = true;
                            } else if (type === 'plan') {
                                controller.criteria.paymentTypePlan = true;
                            }
                        });
                    }
                }

                controller.criteria.brands = [];
                var brands = controller.tabletModal
                    .find('[data-step="' + controller.currentStep.name + '"] #tablet-brand-dropdown')
                    .selectpicker('val');
                if (brands && brands.length > 0) {
                    controller.criteria.brands = brands;
                }

                var includeValue = controller.tabletModal
                    .find('[data-step="' + controller.currentStep.name + '"] #tablet-include-dropdown')
                    .selectpicker('val');
                if (includeValue === 'editorspick') {
                    controller.criteria.showEditorsPickOnly = true;
                } else {
                    controller.criteria.showEditorsPickOnly = false;
                }

                controller.criteria.sortBy = controller.tabletModal
                    .find('[data-step="' + controller.currentStep.name + '"] #sort-dropdown')
                    .selectpicker('val');

                controller.criteria.filter = controller.tabletModal
                    .find('[data-step="' + controller.currentStep.name + '"] #tablet-search')
                    .val();
            }

            controller.filterTablets();
        },

        filterSize: function (p) {
            if (p.id === -1) return true;
            if (controller.criteria.tabletSizeSmall === false && p.size === 'small') return false;
            if (controller.criteria.tabletSizeMedium === false && p.size === 'medium') return false;
            if (controller.criteria.tabletSizeLarge === false && p.size === 'large') return false;
            return true;
        },

        filterPaymentTypes: function (p) {
            if (controller.modalData.showMaxUpfront) return true;

            if (p.id === -1) return true;
            if (!controller.criteria.paymentTypeUpfront || !controller.criteria.paymentTypePlan) {
                var types = controller.getPaymentTypes();
                if (wo$(types).filter(p.paymentTypes).length === 0) return false;
            }
            return true;
        },

        filterMaxUpfront: function (p) {
            if (!controller.modalData.showMaxUpfront) return true;
            if (p.id === -1 || controller.criteria.maxUpfront === -1) return true;
            if (p.cheapestUpfrontCost == null || p.cheapestUpfrontCost > controller.criteria.maxUpfront) {
                return false;
            }
            return true;
        },

        filterBrand: function (p) {
            if (p.id === -1) return true;
            if (
                controller.criteria.brands.filter(function (brand) {
                    return p.manufacturerShortUrl === brand;
                }).length === 0
            ) {
                return false;
            }
            return true;
        },

        filterEditorsPick: function (p) {
            if (p.id === -1) return true;
            if (controller.criteria.showEditorsPickOnly === true && !p.isEditorsPick) {
                return false;
            }
            return true;
        },

        filterSearch: function (p) {
            if (p.id === -1) return true;
            if (
                controller.criteria.filter.length &&
                p.name.toLowerCase().indexOf(controller.criteria.filter.toLowerCase()) < 0 &&
                p.manufacturerName.toLowerCase().indexOf(controller.criteria.filter.toLowerCase()) < 0
            ) {
                return false;
            }
            return true;
        },

        sortTablets: function (a, b) {
            if (a.id === -1) return -1;

            if (controller.criteria.sortBy === 'popular') {
                if (a.rank < b.rank) return -1;
                if (a.rank > b.rank) return 1;
                return 0;
            } else if (controller.criteria.sortBy === 'model') {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            }
            if (a.rank < b.rank) return -1;
            if (a.rank > b.rank) return 1;
            return 0;
        },

        filterTablets: function () {
            controller.filteredTabletsAllBrands = controller.tablets
                .slice()
                .filter(function (p) {
                    return (
                        controller.filterSize(p) &&
                        controller.filterPaymentTypes(p) &&
                        controller.filterMaxUpfront(p) &&
                        controller.filterEditorsPick(p) &&
                        controller.filterSearch(p)
                    );
                })
                .sort(controller.sortTablets);

            controller.filteredTablets = controller.filteredTabletsAllBrands
                .slice()
                .filter(function (p) {
                    return controller.filterBrand(p);
                })
                .sort(controller.sortTablets);

            var oldCount = parseInt(controller.tabletModal.find('[data-tablets-count]').text());
            if (!oldCount || oldCount === 'NaN' || oldCount < 0) {
                oldCount = 0;
            }

            var newCount = controller.filteredTablets.length - 1;
            if (newCount < 0) {
                newCount = 0;
            }

            if (oldCount !== newCount) {
                var countSubheader = controller.tabletModal.find('[data-count-subheader]');
                var countSpan = controller.tabletModal.find('[data-tablets-count]');
                countSubheader.addClass('highlight-fade');
                setTimeout(function () {
                    countSubheader.removeClass('highlight-fade');
                }, 1300);
                countSpan.countTo({ from: oldCount, to: newCount, speed: 500 });
            }

            controller.tabletModal.find('[data-brand-tablets-count]').each(function () {
                var span = wo$(this);
                var brandShortUrl = span.data('brand-tablets-count');
                var brandTabletCount = controller.filteredTabletsAllBrands.filter(function (p) {
                    return p.manufacturerShortUrl === brandShortUrl;
                }).length;
                span.text(brandTabletCount);
            });

            controller.hasValidationErrors = false;
            controller.tabletModal.find('[data-validation-message]').hide();
            controller.tabletModal.find('[data-count-subheader]').show();

            if (
                controller.currentStep.name === 'filter-options' ||
                controller.currentStep.name === 'filter-options-advanced' ||
                controller.currentStep.name === 'tablet-closest-matches'
            ) {
                controller.tabletModal.find('[data-continue-button]').addClass('invisible');
            } else {
                controller.tabletModal.find('[data-continue-button]').removeClass('invisible');
            }

            controller.tabletModal.find('[data-continue-button]').prop('disabled', false);
            controller.tabletModal.find('[data-back-button]').prop('disabled', false);

            if (
                !controller.criteria.tabletSizeSmall &&
                !controller.criteria.tabletSizeMedium &&
                !controller.criteria.tabletSizeLarge
            ) {
                controller.hasValidationErrors = true;
                controller.tabletModal.find('[data-count-subheader]').hide();
                controller.tabletModal.find('[data-no-options-validation]').show();
                controller.tabletModal.find('[data-continue-button]').prop('disabled', true);
                controller.tabletModal.find('[data-back-button]').prop('disabled', true);
                return;
            }
            if (!controller.criteria.paymentTypeUpfront && !controller.criteria.paymentTypePlan) {
                controller.hasValidationErrors = true;
                controller.tabletModal.find('[data-count-subheader]').hide();
                controller.tabletModal.find('[data-no-options-validation]').show();
                controller.tabletModal.find('[data-continue-button]').prop('disabled', true);
                controller.tabletModal.find('[data-back-button]').prop('disabled', true);
                return;
            }
            if (controller.criteria.brands.length <= 0) {
                controller.hasValidationErrors = true;
                controller.tabletModal.find('[data-count-subheader]').hide();
                controller.tabletModal.find('[data-no-options-validation]').show();
                controller.tabletModal.find('[data-continue-button]').prop('disabled', true);
                controller.tabletModal.find('[data-back-button]').prop('disabled', true);
                return;
            }
            if (controller.filteredTablets.length <= 0) {
                controller.hasValidationErrors = true;
                controller.tabletModal.find('[data-count-subheader]').hide();
                controller.tabletModal.find('[data-no-results-validation]').show();
                controller.tabletModal.find('[data-continue-button]').prop('disabled', true);
                controller.tabletModal.find('[data-back-button]').prop('disabled', true);
            }
        }
    };

    WhistleOut.tabletPickerController = controller;
});
